import { UserRole } from './user-role';

export const UserPermissions = Object.freeze({
  canDeleteTeam: 'CAN_DELETE_TEAM',
  canInviteTeam: 'CAN_INVITE_TEAM',
  canViewMyTeam: 'CAN_VIEW_MY_TEAM',
  canEditMyTeam: 'CAN_EDIT_MY_TEAM',
  canEditCompany: 'CAN_EDIT_COMPANY',
  canDeleteMember: 'CAN_DELETE_MEMBER',
  canDetachCompany: 'CAN_DETACH_COMPANY',
  canDeleteCompany: 'CAN_DELETE_COMPANY',
  /**
   * @name canViewAllTeams
   * @description Can view the page with multiple teams
   */
  canViewAllTeams: 'CAN_VIEW_ALL_TEAMS',
  canGetMemberReport: 'CAN_GET_MEMBER_REPORT',
  canAccessUserReport: 'CAN_ACCESS_USER_REPORT',
  canViewAllCompanies: 'CAN_VIEW_ALL_COMPANIES',
  canChangeTeamChampion: 'CAN_CHANGE_TEAM_CHAMPION',
  /**
   * @name canViewTeamInMyCompany
   * @description Can view the team's page of a team in my company
   */
  canViewTeamInMyCompany: 'CAN_VIEW_TEAM_IN_MY_COMPANY',
  canCreateNetworkManager: 'CAN_CREATE_NETWORK_MANAGER',
  canEditMembersOnMyTeam: 'CAN_EDIT_MEMBERS_ON_MY_TEAM',
  canResendInviteOnMyTeam: 'CAN_RESEND_INVITE_ON_MY_TEAM',
  canEditTeamsInMyCompany: 'CAN_EDIT_TEAMS_IN_MY_COMPANY',
  canInviteMembersToMyTeam: 'CAN_INVITE_MEMBERS_TO_MY_TEAM',
  canInviteCompanyToNetwork: 'CAN_INVITE_COMPANY_TO_NETWORK',
  canEditMembersOnMyCompany: 'CAN_EDIT_MEMBERS_ON_MY_COMPANY',
  canResendInviteOnMyCompany: 'CAN_RESEND_INVITE_ON_MY_COMPANY',
  canDeactivateMembersOnMyTeam: 'CAN_DEACTIVATE_MEMBERS_ON_MY_TEAM',
  canDeactivateMembersOnMyCompany: 'CAN_DEACTIVATE_MEMBERS_ON_MY_COMPANY',
  canAccessUserReportForAllCompanies: 'CAN_ACCESS_USER_REPORT_FOR_ALL_COMPANIES',
  canInviteMembersToTeamsInMyCompany: 'CAN_INVITE_MEMBERS_TO_TEAMS_IN_MY_COMPANY',
  /**
   * @name canMoveMemberToAnotherTeamOnMyCompany
   * @description Can select a member to move to another team
   */
  canMoveMemberToAnotherTeamOnMyCompany: 'CAN_MOVE_MEMBER_TO_ANOTHER_TEAM_ON_MY_COMPANY',
  /**
   * @name canSelectTeamToMoveMembersToAnotherTeamOnMyCompany
   * @description Can select a team to move members to another team
   */
  canSelectTeamToMoveMembersToAnotherTeamOnMyCompany:
    'CAN_SELECT_TEAM_TO_MOVE_MEMBERS_TO_ANOTHER_TEAM_ON_MY_COMPANY',
  canMakeChampionOnMyTeam: 'CAN_MAKE_CHAMPION_ON_MY_TEAM',
  canMakeChampionOnMyCompany: 'CAN_MAKE_CHAMPION_ON_MY_COMPANY',
});

export const UserRoleToPermissions = Object.freeze({
  [UserRole.teamMember]: [
    UserPermissions.canViewMyTeam,
    UserPermissions.canAccessUserReport,
    UserPermissions.canInviteMembersToMyTeam,
    UserPermissions.canResendInviteOnMyTeam,
  ],
  [UserRole.companyMember]: [
    UserPermissions.canViewAllTeams,
    UserPermissions.canAccessUserReport,
    UserPermissions.canViewTeamInMyCompany,
    UserPermissions.canResendInviteOnMyCompany,
    UserPermissions.canInviteMembersToTeamsInMyCompany,
    UserPermissions.canMoveMemberToAnotherTeamOnMyCompany,
    UserPermissions.canSelectTeamToMoveMembersToAnotherTeamOnMyCompany,
  ],
  [UserRole.teamManager]: [
    UserPermissions.canViewMyTeam,
    UserPermissions.canEditMyTeam,
    UserPermissions.canDeleteMember,
    UserPermissions.canGetMemberReport,
    UserPermissions.canAccessUserReport,
    UserPermissions.canEditMembersOnMyTeam,
    UserPermissions.canMakeChampionOnMyTeam,
    UserPermissions.canResendInviteOnMyTeam,
    UserPermissions.canInviteMembersToMyTeam,
    UserPermissions.canDeactivateMembersOnMyTeam,
  ],
  [UserRole.companyManager]: [
    UserPermissions.canViewMyTeam,
    UserPermissions.canDeleteTeam,
    UserPermissions.canInviteTeam,
    UserPermissions.canEditMyTeam,
    UserPermissions.canEditCompany,
    UserPermissions.canViewAllTeams,
    UserPermissions.canDeleteMember,
    UserPermissions.canGetMemberReport,
    UserPermissions.canAccessUserReport,
    UserPermissions.canChangeTeamChampion,
    UserPermissions.canViewTeamInMyCompany,
    UserPermissions.canEditMembersOnMyTeam,
    UserPermissions.canEditTeamsInMyCompany,
    UserPermissions.canInviteMembersToMyTeam,
    UserPermissions.canEditMembersOnMyCompany,
    UserPermissions.canViewReportForAllCompany,
    UserPermissions.canResendInviteOnMyCompany,
    UserPermissions.canMakeChampionOnMyCompany,
    UserPermissions.canDeactivateMembersOnMyTeam,
    UserPermissions.canDeactivateMembersOnMyCompany,
    UserPermissions.canInviteMembersToTeamsInMyCompany,
    UserPermissions.canMoveMemberToAnotherTeamOnMyCompany,
    UserPermissions.canSelectTeamToMoveMembersToAnotherTeamOnMyCompany,
  ],
  [UserRole.networkManager]: [
    UserPermissions.canDetachCompany,
    UserPermissions.canDeleteCompany,
    UserPermissions.canViewAllCompanies,
    UserPermissions.canCreateNetworkManager,
    UserPermissions.canInviteCompanyToNetwork,
    UserPermissions.canAccessUserReportForAllCompanies,
  ],
  [UserRole.reporter]: [UserPermissions.canAccessUserReportForAllCompanies],
});
